var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pie-chart",class:{'over-fifty': _vm._percentage > 50, 'has-warning': _vm._percentage > 80 && _vm._percentage < 100, 'has-danger': _vm._percentage >= 100},style:('--rotate: ' + _vm._percentage / 100 + 'turn')})
}
var staticRenderFns = []

export { render, staticRenderFns }